<template>
  <div class="layout">
    <main class="profile-page">
      <h2 class="page-title">Student Profile</h2>

      <div class="profile-container">
        <!-- Profile Photo -->
        <div class="photo-section text-center">
          <img
            :src="profilePhoto || defaultPhoto"
            alt="Profile Photo"
            class="profile-photo rounded-circle"
          />
        </div>

        <!-- Profile Info -->
        <div class="profile-info">
          <div class="info-card">
            <strong>First Name</strong>
            <span>{{ profile.first_name }}</span>
          </div>

          <div class="info-card">
            <strong>Last Name</strong>
            <span>{{ profile.last_name }}</span>
          </div>

          <div class="info-card">
            <strong>Email</strong>
            <span>{{ profile.email }}</span>
          </div>

          <div v-if="profile.phone" class="info-card">
            <strong>Phone</strong>
            <span>{{ profile.phone }}</span>
          </div>

          <div v-if="profile.bio" class="info-card">
            <strong>Bio</strong>
            <span>{{ profile.bio }}</span>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import defaultAvatar from "@/assets/defaultAvatar.png";
import axios from "axios";

export default {
  name: "StudentProfile",
  data() {
    return {
      profilePhoto: null,
      defaultPhoto: defaultAvatar,
      profile: {},
    };
  },
  async mounted() {
    await this.fetchProfile();
  },
  methods: {
    async fetchProfile() {
      try {
        const token = localStorage.getItem("token");

        const res = await axios.get("/student-profile", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        this.profile = res.data;
        this.profilePhoto = this.profile.profile_photo || null;
      } catch (err) {
        console.error(err);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, #0d0015, #1a0026);
}

/* Page */
.profile-page {
  flex: 1;
  padding: 60px 20px;
  color: white;
}

/* Title animation */
.page-title {
  text-align: center;
  margin-bottom: 40px;
  font-size: 30px;
  font-weight: 600;
  animation: fadeDown 0.8s ease;
}

/* Profile container */
.profile-container {
  max-width: 620px;
  margin: auto;
  padding: 35px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(8px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.4);
  animation: floatUp 0.8s ease;
}

/* Profile image */
.photo-section {
  margin-bottom: 25px;
}

.profile-photo {
  width: 130px;
  height: 130px;
  object-fit: cover;
  border: 4px solid #ff00cc;
  box-shadow: 0 0 15px rgba(255, 0, 204, 0.7);
  transition: all 0.3s ease;
}

.profile-photo:hover {
  transform: scale(1.05);
  box-shadow: 0 0 25px rgba(255, 0, 204, 1);
}

/* Info grid */
.profile-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

/* Info cards */
.info-card {
  background: linear-gradient(135deg, #1a0026, #220033);
  border: 1px solid rgba(255, 0, 204, 0.4);
  border-radius: 10px;
  padding: 14px;
  transition: all 0.25s ease;
}

.info-card strong {
  display: block;
  font-size: 13px;
  color: #ff6ad5;
  margin-bottom: 4px;
}

.info-card span {
  font-size: 15px;
  color: #e6e6e6;
}

/* Hover animation */
.info-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 18px rgba(255, 0, 204, 0.4);
}

/* Animations */
@keyframes floatUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .profile-info {
    grid-template-columns: 1fr;
  }

  .profile-container {
    padding: 25px;
  }

  .page-title {
    font-size: 24px;
  }
}
</style>
